import { useTheme } from '@emotion/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Dialog, Flex } from '~/components/blocks';
import { prescriptionQrCodeReaderDialogState } from '~/state/patient/atoms';

import { QrCodeReader } from './QrCodeReader';

export const QrCodeReaderDialog = () => {
  const theme = useTheme();
  const { isOpen } = useAtomValue(prescriptionQrCodeReaderDialogState);
  const resetState = useResetAtom(prescriptionQrCodeReaderDialogState);

  const handleClose = useCallback(() => {
    resetState();
  }, [resetState]);

  return (
    <Dialog invert open={isOpen} onClose={handleClose}>
      <Dialog.Header>処方箋QRコードの読み取り</Dialog.Header>
      <Dialog.Body>
        <Flex justifyContent="center" width="100%" marginTop={theme.space.m}>
          <QrCodeReader />
        </Flex>
      </Dialog.Body>
    </Dialog>
  );
};
